/* eslint-disable global-require */
import "../src/assets/css/vendor/bootstrap.min copy.css";
import "../src/assets/css/vendor/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-image-lightbox/style.css";
import { isMultiColorActive, defaultColor, isDarkSwitchActive } from "./constants/defaultValues";
import { getCurrentColor, setCurrentColor } from "./helpers/Utils";

const color = isMultiColorActive || isDarkSwitchActive ? getCurrentColor() : defaultColor;
setCurrentColor(color);

const render = () => {
  import(`./assets/css/sass/themes/gogo.${color}.scss`).then(() => {
    require("./AppRenderer");
  });
};
render();
